import Tour from 'app/shared/model/Tour';

const Unit = ({
    id = '',
    name = '',
    active = false,
    dateAvailable = '',
    lowPrice = '',
    squareFeet = '',
    tour = {},
} = {}) => ({
    unitId: String(id),
    name: String(name),
    active: Boolean(active),
    dateAvailable: String(dateAvailable),
    price: String(lowPrice),
    sqft: String(squareFeet),
    tour: new Tour(tour),
});

export default Unit;
